





























import { Vue, Component, Prop } from "vue-property-decorator"
import { ICampaign } from "../../../../api_interface"
import moment from "moment"
import { i18nTranslate } from "../../../../../i18n"
import { asyncAlert } from "@/galaxy-cruise/components/AsyncAlert"

@Component
export default class extends Vue {
  @Prop({ required: true })
  settings!: ICampaign

  get s() {
    return this.settings
  }

  get done_count() {
    return Math.min(this.s.count, this.total)
  }

  get done_count_display() {
    const c = this.s.count
    return i18nTranslate(
      {
        en: `{c} Galaxies Classified`,
        ja: `{c}個分類`,
      },
      { c }
    )
  }

  get period_display() {
    return `${moment
      .unix(this.s.period_begin)
      .format("YYYY/MM/DD HH:mm")} - ${moment
      .unix(this.s.period_end)
      .format("MM/DD HH:mm")}`
  }

  get barStyle() {
    return { width: `${Math.round((100 * this.done_count) / this.total)}%` }
  }

  get total() {
    const lastMedal = this.s.medals[this.s.medals.length - 1]
    return lastMedal.count
  }

  get name() {
    return this.s.name ? i18nTranslate(this.s.name) : ""
  }

  get snowmanImage(): string {
    let img = this.s.medals[0].image
    for (const m of this.s.medals) {
      if (this.s.count >= m.count) img = m.image
    }
    if (this.s.i18n) {
      return i18nTranslate(img as {})
    }
    return img as string
  }

  get remainingTime() {
    const duration_in_s = this.s.period_end - this.Store.galaxyCruise.now
    return i18nTranslate(
      {
        en: `Time remaining: {d}`,
        ja: `残り{d}`,
      },
      {
        d:
          duration_in_s >= 60
            ? moment.duration(duration_in_s, "seconds").humanize()
            : i18nTranslate(
                {
                  en: "{s} seconds",
                  ja: "{s}秒",
                },
                { s: Math.round(duration_in_s) }
              ),
      }
    )
  }

  async enlargeImage(campaign: ICampaign) {
    await asyncAlert({ component: CampaignImageViewr, props: { campaign } })
  }
}

import CampaignImageViewr from "./CampaignImageViewer.vue"
